import React, {useEffect} from 'react';
import { useStoreState, useStoreActions } from "easy-peasy";
import { types } from "../lib/store";
import {useTranslation} from "react-i18next";

function VariantSelector() {
  const { t } = useTranslation();

  const hasVariants = useStoreState(state => state.selection.fan.hasVariants);
  const availableVariants  = useStoreState(state => state.selection.fan.variants);
  const variant = useStoreState(state => { return state.selection.designPoint.variant});

  const updateCustomVariant = useStoreActions(actions => actions.selection[types.SET_CUSTOM_VARIANT]);

  const updateStore = (e) => {
    e.preventDefault();

    updateCustomVariant(e.target.value);
  };

  return (
    <>
      {
        hasVariants &&
        <div className="panel panel-info">
          <div className="panel-heading">
            { t("frontend:fan.variant") }
          </div>
          <div className="panel-body">
            <form className="form-horizontal">
              <select className="form-control" onChange={updateStore} value={variant}>
                {
                  availableVariants.sort((a, b) => {
                    return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                  }).map((variant, index) => (
                    <option key={variant.id} value={variant.id}>{variant.name}</option>
                  ))
                }
              </select>
            </form>
          </div>
        </div>
      }
    </>
  );
}

export default VariantSelector;
